export default "__VITE_ASSET__BDm34N0a__"